"use strict";

exports.__esModule = true;
exports.devicePixelRatio = exports.screenHeight = exports.screenWidth = exports.platform = exports.appVersion = exports.appName = void 0;

var _universalEnv = require("universal-env");

var _web = _interopRequireDefault(require("./web"));

var _weex = _interopRequireDefault(require("./weex"));

var _aliMiniapp = _interopRequireDefault(require("./ali-miniapp"));

var _wechatMiniprogram = _interopRequireDefault(require("./wechat-miniprogram"));

var _bytedanceMicroapp = _interopRequireDefault(require("./bytedance-microapp"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function dutyChain() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  for (var i = 0; i < fns.length; i++) {
    var result = fns[i]();

    if (result) {
      return result;
    }
  }
}

function handleWeb() {
  if (_universalEnv.isWeb) {
    return _web.default;
  }

  return null;
}

function handleWeex() {
  if (_universalEnv.isWeex) {
    return _weex.default;
  }

  return null;
}

function handleMiniApp() {
  if (_universalEnv.isMiniApp) {
    return _aliMiniapp.default;
  }

  return null;
}

function handleWeChat() {
  if (_universalEnv.isWeChatMiniProgram) {
    return _wechatMiniprogram.default;
  }

  return null;
}

function handleByteDance() {
  if (_universalEnv.isByteDanceMicroApp) {
    return _bytedanceMicroapp.default;
  }

  return null;
}

function handleDefault() {
  return {};
}

var deviceInfo = dutyChain(handleWeb, handleWeex, handleMiniApp, handleWeChat, handleByteDance, handleDefault);
var appName = deviceInfo.appName;
exports.appName = appName;
var appVersion = deviceInfo.appVersion;
exports.appVersion = appVersion;
var platform = deviceInfo.platform;
exports.platform = platform;
var screenWidth = deviceInfo.screenWidth;
exports.screenWidth = screenWidth;
var screenHeight = deviceInfo.screenHeight;
exports.screenHeight = screenHeight;
var devicePixelRatio = deviceInfo.devicePixelRatio;
exports.devicePixelRatio = devicePixelRatio;